/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'

const Icon = ({ theme, color }) => <svg width='16' height='17' viewBox='-1 -3 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd' d='M12.4406 6.48008C12.4406 9.46242 10.023 11.8801 7.04063 11.8801C4.05829 11.8801 1.64062 9.46242 1.64062 6.48008C1.64062 3.49774 4.05829 1.08008 7.04063 1.08008C10.023 1.08008 12.4406 3.49774 12.4406 6.48008ZM13.4406 6.48008C13.4406 10.0147 10.5752 12.8801 7.04063 12.8801C3.506 12.8801 0.640625 10.0147 0.640625 6.48008C0.640625 2.94546 3.506 0.0800781 7.04063 0.0800781C10.5752 0.0800781 13.4406 2.94546 13.4406 6.48008ZM9 4.00037C9 3.72422 9.22386 3.50037 9.5 3.50037C9.77614 3.50037 10 3.72422 10 4.00037V7.00037V9.50037C10 9.77651 9.77614 10.0004 9.5 10.0004C9.22386 10.0004 9 9.77651 9 9.50037V7.50037H7.5V9.50037C7.5 9.77651 7.27614 10.0004 7 10.0004C6.72386 10.0004 6.5 9.77651 6.5 9.50037V7.50037H4.5C4.22386 7.50037 4 7.27651 4 7.00037V4.00037C4 3.72422 4.22386 3.50037 4.5 3.50037C4.77614 3.50037 5 3.72422 5 4.00037V6.50037H6.5V4.00037C6.5 3.72422 6.72386 3.50037 7 3.50037C7.27614 3.50037 7.5 3.72422 7.5 4.00037V6.50037H9V4.00037Z'
      fill={theme.colors[color]}/>
</svg>

Icon.propTypes = {
    theme: PropTypes.object,
    color: PropTypes.string,
}

export default withTheme(Icon)
